import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { translate } from 'react-i18next';
import FlatButton from 'material-ui/FlatButton';
import { Table } from 'react-bootstrap';
import Loader from 'react-loader-spinner';
import swal from 'sweetalert';

var Config = require('../../../../config');

class ModalLabels extends Component{
	constructor(props, context) {
		super(props, context);
		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.openPDF = this.openPDF.bind(this);
		this.onChangePlantilla = this.onChangePlantilla.bind(this);
		this.printingLabel = this.printingLabel.bind(this);

		this.state = {
		    show: false,
		    number_templates:"",
		    label_type:"",
		    opening:false,
		    options:[],
		    sample_id:"",
		    template_number:"", 
		    labels:[],
			type_extraction_name:"",
			preview_print:{},
			petition_id:""
		};
	}

	componentDidMount() {
		this.props.onRef(this);
	}
	componentWillUnmount() {
		this.props.onRef(null)
	}

	handleClose() {
		this.setState({ show: false});
	}

	handleShow(sample_id, petition_id) {
		var type = 'label_samples';	

		//Criterio funcional,cambiar lugar de colecta
		fetch(Config.default.apiGateway.URL+'functional_criterion?code=lab_preview_print&x=',{ 
			method: 'get',
			headers: new Headers({
				'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
				preview_print: response
			});
		})


		fetch(Config.default.apiGateway.URL+'html_templates?health_facilities_id='+sessionStorage.getItem("health_facilities_id")+
					'&file_type=label_samples&extraction_type=',{ 
			method: 'get',
			headers: new Headers({
			   	'Authorization': 'Bearer ' + sessionStorage.getItem("token"), 
			   	'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                swal('¡Error!', result, 'error');
              });
            }})
		.then(response => {
			if(response !== undefined){
				if(response.res === 0){
					swal('Error', 'No existen formatos definidos para este tipo de impresión.', 'error');
				}else{
					
					this.setState({
						show: true,
						number_templates:response.res,
						sample_id:sample_id,
						template_number:[],
						options:[],
						opening:false,
						label_type: type,
						petition_id:petition_id
					})
				
					var opt = []

					for(var i = 0; i <= parseInt(response.res,10); i++){	
						if(i === 0){
							opt.push({value:i, check:true});
						}else{
							opt.push({value:i-1, check:true});
						}			
					}
					this.setState({
						options: opt
					});
						
				}
			}
				
		})
	}

	//Evento de cambio en elementos formulario
	handleChange = (event, index, value) => {
	    this.setState({
	      [event.target.name]: event.target.value
	    });

	    if(event.target.id !== null){
			var control = document.getElementById(event.target.id);
			if(control !== null){
			  if(control.required && control.className.includes('error')){
				control.classList.remove('error');
			  }else if(control.required && event.target.value===""){
				control.classList.add('error');
			  }
			}
		}
	}

	openPDF(id){
		const select = document.querySelector('div.modal-body');
		const ctrls = select.querySelectorAll('input');
		var etiqueta = []

		if(ctrls[0].checked){
			etiqueta.push(parseInt(ctrls[0].value));
		}else{
			ctrls.forEach(function(ctrl, i){
				if(ctrl.checked){
					etiqueta.push(parseInt(ctrl.value));
				}
			})
		}
		

		this.printingLabel(etiqueta);
	}

	printingLabel(etiqueta){
		var obj ={};
		obj.health_facilities_id = sessionStorage.getItem("health_facilities_id");
		obj.id = this.state.sample_id.toString();
		obj.file_type = this.state.label_type;
		obj.nEtiqueta = etiqueta;
		obj.reference_id = this.state.petition_id;

		this.props.waiting.handleShow('Imprimiendo...');
		fetch(Config.default.apiGateway.URL+"labelsEditor", {
		
			method : 'post',
			body:JSON.stringify(obj),
			responseType: 'blob', //Force to receive data in a Blob Format
			headers : new Headers({
				'Authorization': 'Bearer ' + sessionStorage.getItem('token'),
				'Content-Type': 'application/json'
			})
		})
		.then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.blob();
			}else{
              res.text().then(function(result) {
                swal('¡Error!', result, 'error');
                return;
              });
            }
		})
		.then(response => {
			if(response !== undefined){
				if(this.state.preview_print.value ==="NO"){
					//PREVIEW
					var fileURL = URL.createObjectURL(response);
					window.open(fileURL);
				}else{
					var type = this.state.label_type
					if(this.props.location.pathname === "/petition_register"){
						type = 'label_sample_patients';
					}
					this.props.directPrint(response, type);
				}
				
	       		this.setState({ show: false});
       		}
		})
	}

	onChangePlantilla(e){

		var options = this.state.options;

		const select = document.querySelector('div.modal-body');
		const ctrls = select.querySelectorAll('input');

		ctrls.forEach(function(ctrl, i){
			if(ctrls[0].name == e.target.name){
				if(ctrls[0].checked){
					options[i].check = true;
				}else{
					options[i].check = false;
				}				
			}else{
				if(ctrl.name === e.target.name){
					if(ctrl.checked){
						options[i].check = true;

						var check = 1;
						options.map(function(opt, j){
							if(j > 0 && opt.check)
								check++;
						})

						if(check === options.length)
							options[0].check = true;

					}else{
						if(ctrls[0].checked){
							options[0].check = false;
							options[i].check = false;
						}else{
							options[i].check = false;
						}
					}
				}
			}
		})

		this.setState({
			options: options
		})
	}

	//Verificar si el formulario es valido
	isValidForm() {
		const inputs = document.querySelectorAll('select,input');
	    let isFormValid = true;
	    
	    inputs.forEach(input => {
	    	if(input.required){
		      	const isInputValid = this.showCtrlError(input.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
		  	}
	    });
	    

	    return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		
		if (this.state[refName] === "") {
			if(control !== null){
				control.classList.add('error');
			}
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}
			res = true;
		}

		return res;
	}

	render(){
		const { t } = this.props;
		
		return(
			<Modal show={this.state.show} onHide={this.handleClose}>
		       	<Modal.Header closeButton>
		        	<Modal.Title>{t('content.modal_print_label.MAIN')}</Modal.Title>
		        </Modal.Header>
		        <Modal.Body >
		       		<div className="row" style={{padding:"0px 20px 0px 20px"}}>
				        <div className="col-xs-12 col-sm-5 col-sm-offset-4" >
							<Table responsive hover>
								<thead>
									<tr>
										<th></th>
										<th>Plantillas</th>
									</tr>
								</thead>
								<tbody>
									{this.state.options.lenght !== 0 ?
										this.state.options.map((option, i)=>(
											<tr key={i}>
											
												<td>
													<input type="checkbox" value={option.value} name={'o'+i} id={'o'+i} 
													 onChange={this.onChangePlantilla} checked={option.check}/>
												</td>
												<td>{i === 0 ? 'Todos' : i}</td>
										
											</tr>
										))
									: null
									}
									
								</tbody>
							</Table>
							
						</div>
				    </div>
		        </Modal.Body>
		        <Modal.Footer>
		        <FlatButton primary={true} label={t('content.generics.buttons.print')}  onClick={this.openPDF}/>
		        	<FlatButton primary={true} label={t('content.generics.buttons.reset')}  onClick={this.handleClose}/>
		        </Modal.Footer>

	      	</Modal>
		);
	}
}

export default translate('translations')(ModalLabels) 